import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { useActionState } from "react";
import { type DelPlanMedLegeActionState, delPlanMedLegeServerAction } from "@/server/actions/delPlanMedLege";
export function useDelPlanMedLegeAction(initialDeltMedLegeTidspunkt) {
  const $ = _c(7);
  const {
    narmesteLederId
  } = useParams();
  let t0;
  if ($[0] !== initialDeltMedLegeTidspunkt) {
    t0 = {
      deltMedLegeTidspunkt: initialDeltMedLegeTidspunkt,
      errorDelMedLege: null
    };
    $[0] = initialDeltMedLegeTidspunkt;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const initialDelPlanMedLegeActionState = t0;
  const [t1, delMedLegeAction, isPendingDelMedLege] = useActionState(innerDelMedLegeAction, initialDelPlanMedLegeActionState);
  const {
    deltMedLegeTidspunkt,
    errorDelMedLege
  } = t1;
  function innerDelMedLegeAction(_previousState, t2) {
    const {
      planId
    } = t2;
    return delPlanMedLegeServerAction(narmesteLederId, planId);
  }
  let t3;
  if ($[2] !== delMedLegeAction || $[3] !== deltMedLegeTidspunkt || $[4] !== errorDelMedLege || $[5] !== isPendingDelMedLege) {
    t3 = {
      deltMedLegeTidspunkt,
      delMedLegeAction,
      isPendingDelMedLege,
      errorDelMedLege
    };
    $[2] = delMedLegeAction;
    $[3] = deltMedLegeTidspunkt;
    $[4] = errorDelMedLege;
    $[5] = isPendingDelMedLege;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}